<template>
  <div :class="classes()" class="v-input">
    <v-flex class="input-group__input">
      <label :class="classesLabel()">{{label}} </label>
        <template v-for="item in items">
          <v-flex px-2 class="set-field v-list--dense" @click="onClick(item)">
            <v-layout v-if="item[itemTitle] || item[itemDate]" row wrap >
            <v-flex xs9 sm10>
              <component :is="createComp(getField(item, itemTitle))"/>
            </v-flex>
            <v-flex xs3 sm2 align-end class="v-list__tile__action-text" style="display:block; text-align:end;white-space: normal;"><b>{{formatDateTime(getField(item, itemDate))}}</b>
            </v-flex>
            </v-layout>
            <v-layout row class="v-list__tile__sub-title" style="white-space: normal;">
              <v-flex>
                <component :is="getField(item, itemText) || createComp(Object.values(item)[0])"/>
              </v-flex>
              <v-flex style="text-align: end;">
                <v-component :is="renderIcons(getField(item, itemIcons))" />
              </v-flex>
            </v-layout>
          </v-flex>
        </template>
    </v-flex>
  </div>
</template>

<script>
  import formats from '../../api/formats.js'
  export default {
    name: 'v-items-field',
    props: {
      label: null,
      value: null,
      itemTitle: {
        type: String,
        default: 'title'
      },
      itemDate: {
        type: String,
        default: 'date'
      },
      itemText: {
        type: String,
        default: 'text'
      },
      itemValue: {
        type: String,
        default: 'value'
      },
      itemIcons: {
        type: String,
        default: 'icons'
      },
      smallIcons: {
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        default () {
          return []
        }
      },
      icons: {
        type: Array,
        default () {
          return [
            // {code: 'OK', icon: 'check_circle_outline', class: 'normal--text', text: 'Завершено'},
            {code: 'OK', icon: 'done', class: 'normal--text', text: 'Завершено'},
            {code: 'WARNING', icon: 'error_outline', class: 'warning--text', text: 'Предупреждение'},
            {code: 'ERROR', icon: 'error_outline', class: 'error--text', text: 'Ошибка'},
            {code: 'CANCEL', icon: 'not_interested', class: 'normal--text', text: 'Отменено'},
            {code: 'SCHEDULE', icon: 'schedule', class: 'warning--text', text: 'Запланировано'},
            {code: 'PROCESS', icon: 'loop', class: 'warning--text', text: 'Выполняется'}
          ]
        }
      }
    },
    data: function () {
      return {
        active: null
      }
    },
    created () {
    },
    mounted () {
      this.active = this.parse(this.value)
    },
    watch: {
      value: function (newValue) {
        this.active = this.parse(newValue)
      }
    },
    computed: {
    },
    methods: {
      classes () {
        return {
          // '.pa-0': this.solo,
          'input-group--solo': this.solo,
          'elevation-0': this.flat,
          'input-group': true,
          'input-group--text-field': true,
          'primary--text': this.focused,
          'input-group--focused': this.focused,
          'input-group--dirty': this.isDirty,
          'input-group--tab-focused': true
        }
      },
      classesLabel () {
        return {
          'caption': true,
          'v-label': true,
          'theme--light': !this.focused
        }
      },
      getField (item, fieldName) {
        return item[fieldName] || null
      },
      getItemKey (item) {
        return item[this.itemValue]
      },
      getItemText (item) {
        console.log('getItemText', item)
        return item[this.itemText]
      },
      createComp (template) {
        return formats.createComp(`<span>${template}</span>`)
      },
      formatDateTime (dateTime) {
        return formats.formatDateTime(dateTime).replace(',', '')
      },
      parse (v) {
        if (Array.isArray(v)) {
          return v
        } else {
          return v && v.split(', ') || []
        }
      },
      onChange (e) {
        this.$emit('input', e.join(', '))
      },
      onClick (item) {
        this.$emit('click', item)
      },
      renderIcons (codes) {
        if (!(codes && Array.isArray(codes) && codes.length > 0)) {
          return null
        }
        let smallIcons = this.smallIcons
        let template = `
          <v-tooltip lazy bottom open-delay="500" max-width="20em">
            <span slot="activator">
              <template v-for="flag in flags">
                <v-icon :small="small" :class="flag.class">{{flag.icon}}</v-icon>
              </template>
            </span>
              <template v-for="flag in flags">
                <div>
                  <v-icon small :class="flag.class">{{flag.icon}}</v-icon>
                  {{flag.text}}
                </div>
              </template>
          </v-tooltip>
        `
        let flagSet = new Set(codes)
        let flagList = this.icons
        let flags = flagList.filter(f => flagSet.has(f.code))
        return {
          template: template,
          data: function () {
            return {
              flags: flags,
              small: smallIcons
            }
          }
        }
      }
    }
  }
</script>
<style>
  .set-field {
    overflow-wrap: anywhere;
    font-size: 14px;
  }
  .set-field:hover {
    background: rgba(0, 0, 0, 0.04);
  }
  .set-time {
    display: block;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// ItemsField.vue?6d737491